import HashtagCollection from './HashtagCollection';

export default HashtagCollection;
